import * as universal from '../entries/pages/blog/_page.ts.js';
import stylesheet_4 from '../stylesheets/4.js';
import stylesheet_6 from '../stylesheets/6.js';
import stylesheet_16 from '../stylesheets/16.js';
import stylesheet_8 from '../stylesheets/8.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/blog/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/blog/+page.ts";
export const imports = ["_app/immutable/nodes/5.e6b50369.js","_app/immutable/chunks/BlogContentCard.9359a2c7.js","_app/immutable/chunks/control.f5b05b5f.js","_app/immutable/chunks/scheduler.cba25ae0.js","_app/immutable/chunks/index.e8799153.js","_app/immutable/chunks/each.4a3b5091.js","_app/immutable/chunks/index.6d2b3d0a.js","_app/immutable/chunks/Wrapper.5a8cf0a2.js","_app/immutable/chunks/Input.4b038b5f.js"];
export const stylesheets = ["_app/immutable/assets/5.698818b7.css","_app/immutable/assets/BlogContentCard.72565f8f.css","_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Input.8fc26899.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/5.698818b7.css": stylesheet_4,
	"_app/immutable/assets/BlogContentCard.72565f8f.css": stylesheet_6,
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_16,
	"_app/immutable/assets/Input.8fc26899.css": stylesheet_8
});
